import React from 'react';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { ToolButton } from '../../../../components';
import { IToolButtonProps } from '../../../../interfaces';
import { roleDataService } from '../../services';
import { hideAlert, showAlert } from '../../../../components/alert/Alert';
import { AlertTypeEnum, StateTopicEnum } from '../../../../enums';
import { useNavigate } from 'react-router-dom';
import { getCurrentData, publish } from '../../../../hooks';
import { UserPermissions } from '../../../../../src/definitions';
import { securityService } from '../../../../../src/_global/services';

export default function DeleteButton({ config, item }: IToolButtonProps) {
  const { id: moduleId } = config;
  const navigate = useNavigate();

  const handleClick = () => {
    const handleYes = async () => {
      await roleDataService.delete(item._id);
      hideAlert();
      const pageNo = getCurrentData(StateTopicEnum.LibraryPage);
      const searchTerm = getCurrentData(StateTopicEnum.LibrarySearch);
      navigate(`/${moduleId}?search=${searchTerm ?? ''}&page=${pageNo ?? 1}`, {
        replace: true
      });

      publish(StateTopicEnum.LibrarySearchAndPage, {
        page: pageNo,
        search: searchTerm
      });
    };
    showAlert({
      content: 'Are you sure you want to delete this user role?',
      options: {
        actions: [
          { text: 'No', onClick: hideAlert, primary: true },
          { text: 'Yes', onClick: handleYes }
        ],
        type: AlertTypeEnum.Error
      }
    });
  };

  return (
    <ToolButton
      text='Delete'
      icon={faTrash}
      onClick={() => {
        handleClick();
      }}
      invalid={!securityService.checkRoleAccess(UserPermissions.editUserRoles)}
    />
  );
}
